export default __webpack_public_path__ + "static/media/profile-white.33794de0.svg";